import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/")({
  component: Index,
  head: () => ({
    meta: [
      { title: "Quick Credit | Personal Loans $1,000–$50,000 from 5.96% APR" },
      {
        name: "description",
        content:
          "Compare personal loans from $1,000 to $50,000 over 12–60 months. Fixed APRs from 5.96% to 35.99%. Check your rate with no impact to your credit score.",
      },
      { property: "og:title", content: "Quick Credit | Personal Loans from 5.96% APR" },
      {
        property: "og:description",
        content:
          "Transparent personal loans from $1,000 to $50,000. Clear rates, no hidden fees, responsible lending.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://quickcredit.live/" },
      { property: "og:image", content: "https://quickcredit.live/social-preview.png" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://quickcredit.live/social-preview.png" },
    ],
  }),
});
